import { create } from 'zustand';
import { type PersonAssetStore } from '@/entities/person';


export const usePersonAssetStore = create<PersonAssetStore>((set, get) => ({
  personAssets: [],
  setPersonAssets: (personAssets) => set({ personAssets }),
  addPersonAsset: (personAsset) =>
    set((state) => ({ personAssets: [...state.personAssets, personAsset] })),
  deletePersonAsset: (id) =>
    set((state) => ({
      personAssets: state.personAssets.filter((pa) => pa.id !== id),
    })),
  getPersonAssetsByPerson: (personId) =>
    get().personAssets.filter((pa) => pa.person_id === personId),
  getPersonAssetsByAsset: (assetId) =>
    get().personAssets.filter((pa) => pa.asset_id === assetId),
  deletePersonAssetsByPerson: (personId) =>
    set((state) => ({
      personAssets: state.personAssets.filter((pa) => pa.person_id !== personId),
    })),
  deletePersonAssetsByAsset: (assetId) =>
    set((state) => ({
      personAssets: state.personAssets.filter((pa) => pa.asset_id !== assetId),
    })),
}));
